<cerrix-editor [value]="htmlValue" (valueChange)="updateValue($event)"></cerrix-editor>
